import { Card, Empty, Table } from "antd";
import { postApis } from "../../Common/apis";
import { fleetVehicleDetailsApiUrl } from "../../Common/endpoints";
import { UNITS } from "../../Common/Constants";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { formatHourAndMins } from "../../Common/Utils";

const FleetTable = ({ filterDetails }) => {
  const [fleetVehicleTableData, setFleetVehicleTableData] = useState({
    List: [],
    totalElements: 0,
  });
  const [paginationDetails, setPaginationDetails] = useState({
    current: 1,
    pageSize: 10,
    field: "imei",
    order: "ascend",
  });
  const authToken = localStorage.getItem("authToken");

  const getFleetVehicles = async () => {
    if (
      filterDetails?.dateRange?.[0] &&
      (filterDetails?.imei?.length > 1 || filterDetails?.imei.includes("all"))
    ) {
      const data = {
        fleetId: filterDetails.fleet,
        from: Math.floor(filterDetails?.dateRange?.[0]),
        to:
          dayjs(filterDetails?.dateRange?.[1]) > dayjs().subtract(1, "hour")
            ? Math.floor(dayjs())
            : Math.floor(filterDetails?.dateRange?.[1]),
        imei: filterDetails.imei.filter((item) => item !== "all"),
        pageNo: paginationDetails.current - 1,
        pageSize: paginationDetails.pageSize,
        sortDirection: paginationDetails?.order === "ascend" ? "ASC" : "DESC",
        sortBy: [
          paginationDetails?.field === "distanceTravelled"
            ? "distance"
            : paginationDetails?.field,
        ],
      };
      await postApis(fleetVehicleDetailsApiUrl, data, authToken)
        .then((response) => {
          setFleetVehicleTableData((prev) => ({
            ...prev,
            List: response?.data?.data || [],
            totalElements: response?.data?.totalElements,
          }));
        })
        .catch((error) => {
          setFleetVehicleTableData({ List: [], totalElements: 0 });
          console.log(error);
        });
    }
  };

  useMemo(() => {
    if (fleetVehicleTableData.totalElements) {
      getFleetVehicles();
    }

    // eslint-disable-next-line
  }, [paginationDetails]);

  useEffect(() => {
    if (paginationDetails?.current > 1) {
      setPaginationDetails((prev) => ({
        ...prev,
        current: 1,
        pageSize: 10,
        field: "imei",
        order: "ascend",
      }));
    } else {
      getFleetVehicles();
    }

    // eslint-disable-next-line
  }, [filterDetails]);

  const handlePageChange = (pagination, filters, sorter) => {
    setPaginationDetails({
      current: pagination.current,
      pageSize: pagination.pageSize,
      ...sorter,
    });
  };

  const columns = [
    {
      title: "IMEI",
      dataIndex: "imei",
      key: "imei",
      align: "center",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "imei" && paginationDetails?.order,
      sorter: true,
    },
    {
      title: "Distance Travelled",
      dataIndex: "distanceTravelled",
      key: "distanceTravelled",
      align: "center",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "distanceTravelled" &&
        paginationDetails?.order,
      sorter: true,
      render: (distanceTravelled) => `${distanceTravelled} ${UNITS.KM}`,
    },
    {
      title: "Usage Time",
      dataIndex: "usageTime",
      key: "usageTime",
      align: "center",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "usageTime" && paginationDetails?.order,
      sorter: true,
      render: (usageTime) => formatHourAndMins(usageTime) || `0 ${UNITS.HOURS}`,
    },
    {
      title: "Discharge",
      dataIndex: "discharge",
      key: "discharge",
      align: "center",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "discharge" && paginationDetails?.order,
      sorter: true,
      render: (discharge) => `${discharge || 0} ${UNITS.PERCENT}`,
    },
    {
      title: "Charging Time",
      dataIndex: "chargingTime",
      key: "chargingTime",
      align: "center",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "chargingTime" && paginationDetails?.order,
      sorter: true,
      render: (chargingTime) =>
        formatHourAndMins(chargingTime) || `0 ${UNITS.HOURS}`,
    },
  ];

  return fleetVehicleTableData?.List.length > 0 ? (
    <Table
      data-testid="vehicle-list"
      columns={columns}
      className="fleet-vehicle-table"
      dataSource={fleetVehicleTableData?.List}
      rowKey={(record) => record.imei}
      scroll={{ x: "100%" }}
      onChange={handlePageChange}
      pagination={{
        current: paginationDetails.current,
        pageSize: paginationDetails.pageSize,
        total: fleetVehicleTableData?.totalElements,
        showSizeChanger: false,
        showQuickJumper: false,
        hideOnSinglePage: true,
      }}
    />
  ) : (
    <Card className="h100">
      <div className="pd3025" data-testid="empty-vehicle-list">
        <Empty />
      </div>
    </Card>
  );
};
export default FleetTable;
